import { useCallback, useEffect, useState } from "react";
import axios from "axios";

export const useTaxOffices = (countryId) => {
  const [taxOffices, setTaxOffices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);

  const refreshTaxOffices = useCallback(() => {
    setReloadToken((current) => current + 1);
  }, []);

  useEffect(() => {
    if (!countryId) {
      setTaxOffices([]);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);

    axios
      .get("/api/v1/taxOffices", { params: { countryId } })
      .then((response) => {
        if (!cancelled) {
          setTaxOffices(response.data || []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setTaxOffices([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [countryId, reloadToken]);

  return { taxOffices, isLoading, refreshTaxOffices };
};
